import { createServerFn } from "@tanstack/react-start";

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export interface ArticleFaqItem {
  question: string;
  answer: string;
}

export interface ArticleFaqResult {
  success: boolean;
  items?: ArticleFaqItem[];
  cached?: boolean;
  error?: string;
}

/**
 * Two reader questions for a story. Public and cache first: the first visitor
 * triggers generation, everyone after reads the saved version.
 */
export const getArticleFaq = createServerFn({ method: "POST" })
  .inputValidator((input: { articleId: string; languageCode?: string }) => {
    if (!UUID_RE.test(input?.articleId ?? "")) throw new Error("Invalid article id");
    const languageCode =
      input.languageCode === "no" || input.languageCode === "zh-Hant" ? input.languageCode : "en";
    return { articleId: input.articleId, languageCode };
  })
  .handler(async ({ data }): Promise<ArticleFaqResult> => {
    const { getArticleFaqById } = await import("./articleFaq.server");
    try {
      return await getArticleFaqById(data.articleId, data.languageCode);
    } catch (error) {
      console.error("getArticleFaq failed", error);
      return { success: false, error: "Could not build questions" };
    }
  });
